import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const postEditCertificate = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.CERTIFICATE_MANAGEMENT.POST_EDIT_CERTIFICATE,
    data
  );
};

export default postEditCertificate;
